import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ArrowUpRight } from "lucide-react";

const faqs = [
  {
    q: "Hur bokar jag en verkstadstid hos ZAM?",
    a: "Välj tjänst, fyll i registreringsnummer och önskat datum. ZAM återkommer sedan för att bekräfta tid och nästa steg.",
  },
  {
    q: "Jag vet inte exakt vad som är fel på bilen — kan ni hjälpa ändå?",
    a: "Absolut. Välj Felsökning & Diagnostik i bokningen så börjar vi med att ta reda på vad som orsakar problemet.",
  },
  {
    q: "Kan ni hjälpa till inför eller efter besiktningen?",
    a: "Ja. ZAM kan gå igenom bilen inför besiktning och hjälpa till med sådant som behöver åtgärdas efteråt.",
  },
  {
    q: "Vad ingår i en AC-service?",
    a: "En AC-service kan omfatta kontroll av systemet, läcksökning och åtgärder som behövs för att få klimatanläggningen att fungera som den ska.",
  },
  {
    q: "Får jag en kostnadsuppskattning innan arbetet påbörjas?",
    a: "Ja. Målet är att du ska veta vad som ska göras och vilken kostnad du kan förvänta dig innan arbetet sätts igång.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 lg:py-36 bg-[#F8FAFC]">
      <div className="max-w-[1360px] mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <span className="eyebrow">05 — Vanliga frågor</span>
          <h2 className="hero-text mt-5 text-[9vw] sm:text-[6vw] lg:text-[4.4vw] xl:text-[64px]">
            Bra att veta<br />
            <span className="italic text-[#1F3C88]">innan du bokar.</span>
          </h2>
          <p className="mt-6 text-slate-600 text-[0.98rem] leading-relaxed max-w-sm">
            Osäker på vilken tjänst du behöver? Börja med en bokningsförfrågan så
            kan ZAM ta dialogen vidare därifrån.
          </p>
          <a
            href="#boka"
            className="mt-8 inline-flex items-center gap-2 text-slate-900 font-semibold group"
          >
            Kontakta oss
            <span className="w-10 h-10 rounded-full bg-[#D52027] text-white grid place-items-center group-hover:scale-110 transition-transform">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <Accordion
            type="single"
            collapsible
            data-testid="faq-accordion"
            className="w-full"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-slate-300 first:border-t"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display text-[1.3rem] lg:text-[1.55rem] text-slate-900 tracking-tight py-6 hover:no-underline [&[data-state=open]]:text-[#1F3C88]"
                >
                  <span className="flex items-start gap-5 text-left">
                    <span className="font-mono text-[0.7rem] text-slate-400 pt-2 shrink-0 w-7">
                      0{i + 1}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-[0.98rem] leading-relaxed pl-12 pr-6 pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
